<template>
  <div class="info-item">
    <dt class="info-item__dt">{{ title }}:</dt>
    <dd class="info-item__dd"><slot /></dd>
  </div>
</template>

<script>
export default {
  name: "ContactsSectionInfoItem",
  props: {
    title: String
  }
};
</script>

<style lang="scss" scoped>
.info-item {
  &:not(:last-child) {
    margin-right: 30px;
  }

  &__dt {
    color: colors(text-2);
    font-weight: fw(bold);
    font-size: 22px;
    white-space: nowrap;
  }

  &__dd {
    font-size: 18px;
  }

  @include breakpoint("md-and-down") {
    &:not(:last-child) {
      margin-right: 0;
      margin-bottom: 10px;
    }
  }
}
</style>
